/**
 * Pure helper functions used by the customer Lane Booking page and its
 * extracted dialog components. Kept here so the helpers don't pull React
 * state along with them.
 */

/** Format a YYYY-MM-DD date string as e.g. "Monday, May 12". */
export const formatDate = (dateStr) => {
  const date = new Date(dateStr + 'T00:00:00');
  return date.toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  });
};

/** Convert a 24h "HH:MM" string into a 12h "h:MM AM/PM" string. */
export const formatTime = (time24) => {
  if (!time24) return '';
  const [hours, minutes] = time24.split(':');
  const h = parseInt(hours, 10);
  const ampm = h >= 12 ? 'PM' : 'AM';
  const h12 = h % 12 || 12;
  return `${h12}:${minutes} ${ampm}`;
};

/** Add `duration` minutes to a "HH:MM" start time and return "HH:MM". */
export const computeEndTime = (start_time, duration) => {
  if (!start_time || !duration) return '';
  const [h, m] = String(start_time).split(':').map(Number);
  if (Number.isNaN(h) || Number.isNaN(m)) return '';
  const total = h * 60 + m + parseInt(duration, 10);
  const eh = Math.floor(total / 60) % 24;
  const em = total % 60;
  return `${String(eh).padStart(2, '0')}:${String(em).padStart(2, '0')}`;
};

/** Look up a lane's price for the given duration; 0 when unknown. */
export const getPrice = (lanes, laneId, duration) => {
  const lane = (lanes || []).find((l) => l.id === laneId);
  return lane?.pricing?.[duration] || 0;
};
